import { createFileRoute } from '@tanstack/react-router';
import { CassaPage } from '@/features/cassa/CassaPage';

type CassaPanel = 'magazzino' | 'fiscale';
type CassaSearch = { panel?: CassaPanel };

export const Route = createFileRoute('/_app/cassa/')({
  // Deep-link dai quick-access della home: /cassa?panel=magazzino | fiscale
  validateSearch: (search: Record<string, unknown>): CassaSearch => {
    const p = search.panel;
    return p === 'magazzino' || p === 'fiscale' ? { panel: p } : {};
  },
  component: CassaRoute,
});

function CassaRoute() {
  const { panel } = Route.useSearch();
  return <CassaPage initialPanel={panel} />;
}
